import React, { Component } from "react";
import { connect } from "react-redux";

import MediasListComponent from "./MediasListComponent";

import { fetchMedias } from "Thunks";

import { LAYOUT_DISPOSITIONS } from "Config";

export class MediasList extends Component {
  componentDidMount() {
    const { fetchMedias, disposition, conditions, order } = this.props;

    let limit = 0;
    for (const blocType of disposition || []) {
      limit += LAYOUT_DISPOSITIONS.MEDIA[blocType];
    }
    fetchMedias({
      limit: limit === 0 ? 8 : limit,
      conditions,
      order
    });
  }

  render() {
    return <MediasListComponent {...this.props} />;
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  medias:
    state.medias.items && state.medias.items[ownProps.order]
      ? state.medias.items[ownProps.order]
      : [],
  fetching: state.medias.fetching,
  fetched: state.medias.fetched,
  lng: state.params.lng
  //navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  fetchMedias: options => dispatch(fetchMedias(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediasList);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/MediasList/index.js